export default __webpack_public_path__ + "static/logo-new-min-f2c4b022c56fd17e794f2edc4b78c2c4.png";